module.exports = __webpack_public_path__ + "static/media/Raggruppa_71.0ed4ec46.svg";